/**
 * Generated by orval v7.21.0 🍺
 * Do not edit manually.
 * DermOnCall Patient API
 * OpenAPI spec version: 1.0
 */
import { useMutation } from '@tanstack/react-query';
import type {
  MutationFunction,
  QueryClient,
  UseMutationOptions,
  UseMutationResult,
} from '@tanstack/react-query';

import type {
  CreateSessionBodyOne,
  CreateSessionBodyThree,
  CreateSessionBodyTwo,
  CreateSessionResponse,
} from './api.schemas';

import { api } from '../util/http';

export const createSession = (
  createSessionBody: CreateSessionBodyOne | CreateSessionBodyTwo | CreateSessionBodyThree,
  signal?: AbortSignal,
) => {
  return api<CreateSessionResponse>({
    url: `/api/session`,
    method: 'POST',
    data: createSessionBody,
    signal,
  });
};

export const getCreateSessionMutationOptions = <TError = unknown, TContext = unknown>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof createSession>>,
    TError,
    { data: CreateSessionBodyOne | CreateSessionBodyTwo | CreateSessionBodyThree },
    TContext
  >;
}): UseMutationOptions<
  Awaited<ReturnType<typeof createSession>>,
  TError,
  { data: CreateSessionBodyOne | CreateSessionBodyTwo | CreateSessionBodyThree },
  TContext
> => {
  const mutationKey = ['createSession'];
  const { mutation: mutationOptions } = options
    ? options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey
      ? options
      : { ...options, mutation: { ...options.mutation, mutationKey } }
    : { mutation: { mutationKey } };

  const mutationFn: MutationFunction<
    Awaited<ReturnType<typeof createSession>>,
    { data: CreateSessionBodyOne | CreateSessionBodyTwo | CreateSessionBodyThree }
  > = (props) => {
    const { data } = props ?? {};

    return createSession(data);
  };

  return { mutationFn, ...mutationOptions };
};

export type CreateSessionMutationResult = NonNullable<Awaited<ReturnType<typeof createSession>>>;
export type CreateSessionMutationBody =
  | CreateSessionBodyOne
  | CreateSessionBodyTwo
  | CreateSessionBodyThree;
export type CreateSessionMutationError = unknown;

export const useCreateSession = <TError = unknown, TContext = unknown>(
  options?: {
    mutation?: UseMutationOptions<
      Awaited<ReturnType<typeof createSession>>,
      TError,
      { data: CreateSessionBodyOne | CreateSessionBodyTwo | CreateSessionBodyThree },
      TContext
    >;
  },
  queryClient?: QueryClient,
): UseMutationResult<
  Awaited<ReturnType<typeof createSession>>,
  TError,
  { data: CreateSessionBodyOne | CreateSessionBodyTwo | CreateSessionBodyThree },
  TContext
> => {
  const mutationOptions = getCreateSessionMutationOptions(options);

  return useMutation(mutationOptions, queryClient);
};
